import React, { Component } from 'react';
import { Router, Route, Switch, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { history } from './helpers/history';
// import { alertActions } from './actions/alerts';
import { PrivateRoute } from './components/PrivateRoute';
import HomePage from './containers/HomeContainer';
import LoginPage from './containers/LoginContainer';
// import QRContainer from './containers/QRContainer';
/* import PaymentContainer from './containers/PaymentContainer';
import ChargeTrayContainer from './containers/ChargeTrayContainer';
import CheckBookContainer from './containers/CheckBookContainer';
import PaymentsContainer from './containers/PaymentsContainer';
import CheckbookPayContainer from './containers/CheckbookPayContainer';
import CheckbookChargeContainer from './containers/CheckbookChargeContainer'; */
import CustomerContainer from './containers/CustomerContainer';
import Pie from './components/Charts/Pie';
import ToolBar from './components/Menu/ToolBar';
import SnackBars from './components/Complements/SnackBars';
import { deviceDetect, isMobile } from 'react-device-detect';
import CodesContainer from './containers/CodesContainer';
// import group from "group-reduce";
//import TaxeContainer from './containers/TaxeContainer';
import { links } from './constants/link-constants';
//import TransfersContainer from './containers/TransfersContainer';
import UserRegisterContainer from './containers/UserRegisterContainer';
import PasswordChangeContainer from './containers/PasswordChangeContainer';
import IdleTimer from 'react-idle-timer'

//import Can from './services/can';
import RecoverContainer from './containers/RecoverContainer';
import { ThemeProvider } from '@material-ui/styles';
//import ElectricTaxeContainer from './containers/ElectricTaxeContainer';
import AcademyTaxeContainer from './containers/AcademyTaxeContainer';
import { filterArrayEqual, filterArrayMoreEqual, filterArrayNotEqual } from './functions/arrays';
//import { orderAccountsVouchers } from './functions/orderaccounts';
import { sendMobile } from './functions/mobile';
import HomeInfoUserMobile from './components/Complements/HomeInfoUserMobile';
import ChangeQuotasContainer from './containers/ChangeQuotasContainer';
import MovementsContainer from './containers/MovementsContainer';
import DepositsContainer from './containers/DepositsContainer';
import CreditsContainer from './containers/CreditsContainer';
import InfoDeviceUser from './components/Home/InfoDeviceUser';
import CreditsPayContainer from './containers/CreditsPayContainer';
import CertificatesContainer from './containers/CertificatesContainer';
import ConsultCertificatesContainer from "./containers/ConsultCertificatesContainer"
import CertificateValidateContainer from './containers/CertificateValidateContainer';
import VoucherServicePayContainer from './containers/VoucherServicePayContainer';
import VoucherTransfertContainer from './containers/VoucherTransfertContainer';
/*import VoucherCreditsPayContainer from './containers/VoucherCreditsPayContainer';

import VoucherPaymentMeterContainer from './containers/VoucherPaymentMeterContainer';*/
import ElectronicRechargesContainer from './containers/ElectronicRechargesContainer'
import PaymentServiceSwitchContainer from './containers/PaymentServiceSwitchContainer';
import { themePrimary } from './styles/PrimaryTheme';
import { themeLogin } from './styles/LoginTheme';
import { servicesSocket } from './functions/socket';
import QuestionsContainer from './containers/QuestionsContainer';
import { chargeData } from "./actions/chargeCoreData";
import * as allActions from './functions/loguin-imports'
//import ToolbarLogout from './components/Menu/ToolbarLogout';
import HomeLogoutContainer from './containers/HomeLogoutContainer';
//import { CssBaseline } from '@material-ui/core';
import CreditCardPaymentContainer from './containers/CreditCardPaymentContainer';
import VoucherCreditCardPaymentContainer from './containers/VoucherCreditCardPaymentContainer';
import UsernameChangeContainer from './containers/UsernameChangeContainer';
import TransfersOwnContainer from './containers/TransfersOwnContainer';
import TransfersInternalContainer from './containers/TransfersInternalContainer';
import TransfersExternalContainer from './containers/TransfersExternalContainer';
import AccountAdministrationContainer from './containers/AccountAdministrationContainer';
import CreditRequestTestContainer from './containers/CreditRequestTestContainer';
import MaintenanceContainer from './containers/MaintenanceContainer';
import TransferOptionsContainer from './containers/TransferOptionsContainer';

import { feathersCreateData } from './services';
import PaymentOptionsContainer from './containers/PaymentOptionsContainer';
import PaymentServiceSwitchSupaContainer from './containers/PaymentServiceSwitchSupaContainer';

import QrGeneratesContainer from './containers/QrGeneratesContainer';
import ReportQr from './containers/ReportQr';
import { Button, Dialog } from '@mui/material';
import { Close } from '@mui/icons-material';
import { urlBase } from './services/urls';
import SuggestionContainer from './containers/SuggestionContainer';
import VoucherTranviaPayContainer from './containers/VoucherTranviaPayContainer';
import TranviaContainer from './containers/TranviaContainer';
import VouchersQrPayment from './containers/VouchersQrPayment';
import SendPayRoleContainer from './containers/SendPayRole/SendPayRoleContainer';
import ValidatePayRoleContainer from './containers/SendPayRole/ValidatePayRoleContainer';
import CheckPayrollContainer from './containers/SendPayRole/CheckPayrollContainer';
import TransactionsActivityContainer from './containers/TransactionsActivityContainer';
function isEmpty(obj) {
    for (var key in obj) {
        if (obj.hasOwnProperty(key))
            return false;
    }
    return true;
}

class App extends Component {

    state = {
        openSnackbar: false,
        message: '',
        type: '',
        dataNotification: [],
        codesData: [],
        timeout: 300000,
        isTimedOut: true,
        dataDevice: {},
        maintenanceTime: '',
        popup: false,
        isDark: false
    }

    constructor(props) {
        super(props);

        history.listen((location, action) => {
            for (const link in links) {
                (location.pathname === link) && this.props.setActualPage(links[link])
                // console.log(`links.${link} = ${links[link]}`);
            }
            // clear alert on location change
            // this.props.clearAlerts();
            if (location.pathname === '/transfers-qr') {
                const send = {
                    type: 'action',
                    action: 'openQRReaderTransfersQr',
                    function: 'QR_PAY',
                    data: this.props.balances
                }
                sendMobile(JSON.stringify(send))
            } else {
                isMobile && sendMobile(JSON.stringify({ type: 'link', data: location.pathname }))
            }

        });
        this.idleTimer = null
        this.onAction = this._onAction.bind(this)
        this.onActive = this._onActive.bind(this)
        this.onIdle = this._onIdle.bind(this)
    }

    handleDarkTheme = () => {
        this.setState(prev => ({
            isDark: !prev.isDark
        }))
    }
    _onAction(e) {
        //const { isTimedOut } = this.state
        //console.log('user did something', e)
        //isTimedOut &&
        //this.setState({ isTimedOut: false })
        // this.idleTimer.reset();
    }

    _onActive(e) {
        //console.log("onActive: ", e)
        //this.setState({ isTimedOut: false })
    }

    _onIdle(e) {
        // console.log("onidle: ", e)
        // console.log(new Date())
        //const { isTimedOut } = this.state
        //if (isTimedOut) {
        this.setOnLogout()
        //} else {
        // this.setState({showModal: true})
        // this.idleTimer.reset();
        //this.setState({ isTimedOut: true })
        //}

    }

    dataChart = () => {
        const { consolidates, balances } = this.props
        let result = []
        let allDataByTypeAccount = []

        //Cuentas de Ahorro
        let totalBalance = 0
        if (!isEmpty(this.props.user2) && balances.length > 0) {
            const responseFilterAccounts = filterArrayNotEqual(balances, 'PRODUCTALIAS', 'CERTIFICADOS')/* .map(data => {
                return result.push({
                    type: 1,
                    name: `<b>${data.tipoCuenta}: $ ${data.saldoDisponible}</b>`,
                    y: data.saldoDisponible
                })
            })*/

            for (let i = 0; i < responseFilterAccounts.length; i++) {
                let filterDataRepeat = result.filter((item) => item.accountType === responseFilterAccounts[i].PRODUCTALIAS)

                if (filterDataRepeat.length === 0) {
                    allDataByTypeAccount = responseFilterAccounts.filter((row) => row.PRODUCTALIAS === responseFilterAccounts[i].PRODUCTALIAS)
                    //allDataByTypeAccount.reduce( (previousRow, currentRow) => parseFloat(previousRow.saldoDisponible) + parseFloat(currentRow.saldoDisponible), 0)
                    for (let y = 0; y < allDataByTypeAccount.length; y++) {
                        totalBalance += parseFloat(allDataByTypeAccount[y].SALDOINT)
                    }

                    result.push({
                        type: 1,
                        name: `<b>${responseFilterAccounts[i].PRODUCTALIAS}: $ ${parseFloat(totalBalance).toFixed(2)}</b>`,
                        y: totalBalance,
                        accountType: responseFilterAccounts[i].PRODUCTALIAS
                    })

                    totalBalance = 0
                }

            }

            //console.log(result) consolidates.depositosAPlazo.length > 0 && consolidates.prestamos.length > 0

        }

        //Certificados
        totalBalance = 0
        for (let y = 0; y < balances.length; y++) {
            if (balances[y].PRODUCTALIAS === 'CERTIFICADOS') {
                totalBalance += parseFloat(balances[y].SALDOINT)
            }
        }

        result.push({
            type: 1,

            name: `<b>CERTIFICADOS: $ ${parseFloat(totalBalance).toFixed(2)}</b>`,
            y: totalBalance,
            accountType: "CERTIFICADOS"
        })

        //Depósitos a Plazo
        totalBalance = 0
        for (let y = 0; y < balances.length; y++) {
            if (balances[y].PRODUCTALIAS === 'CERTIFICADOS DE DEPOSITO') {
                totalBalance += parseFloat(balances[y].SALDOINT)
            }
        }

        result.push({
            type: 1,
            name: `<b>DEPÓSITOS A PLAZO FIJO: $ ${parseFloat(totalBalance).toFixed(2)}</b>`,
            y: totalBalance,
            accountType: "DEPÓSITOS A PLAZO FIJO"
        })

        //Préstamos y/o Créditos
        totalBalance = 0
        for (let y = 0; y < consolidates.prestamos.length; y++) {
            totalBalance += parseFloat(consolidates.prestamos[y].SALDOINT)
        }

        result.push({
            type: 1,
            name: `<b>CRÉDITOS: $ ${parseFloat(totalBalance).toFixed(2)}</b>`,
            y: totalBalance,
            accountType: "CRÉDITOS"
        })

        // console.log(result)

        return result
    }

    fetchFromRemote = () => console.log('fetchFromRemote')

    RedirectMobile = () => history.push('/password-change')

    validateMaintenance = async () => {
        const maintenance = await feathersCreateData('validate-maintenance-time', {})()
        this.setState({ maintenanceTime: maintenance.status })
        //console.log(maintenance)
        //console.log(maintenance.status)
        //return maintenance
    }

    validatePopup = async () => {
        const popup = await feathersCreateData('validate-show-popup', {})()
        this.setState({ popup: popup.status })
    }

    closePopup = () => {
        this.setState({ popup: false })
    }

    componentDidMount() {
        this.setState({ dataDevice: deviceDetect() })
        this.props.setActualPage('Estado de cuenta')
        //const { maintenanceTime } = this.state
        /* let borrar = getGeoInfo()
        // console.log('getGeoInfo()', getGeoInfo())
        // console.log('getGeoInfo()', borrar) */
        ////
        //console.log(this.state.dataDevice)
        this.validateMaintenance()
        this.validatePopup()
        //console.log('this.validateMaintenance()', this.validateMaintenance())
        //console.log('maintenanceTime', this.state.maintenanceTime)
        /* if (this.state.maintenanceTime === true) {
            history.push('/maintenance')
        } */
        if (localStorage.auth) {
            // console.log('maintenanceTime', this.state.maintenanceTime)
            this.props.loginSuccess().then(({ payload, message }) => {
                if (message) {
                    history.push('/home')
                }
                if (payload) {
                    servicesSocket(payload.user, this.props)
                    chargeData(this.props, payload).then(res => {
                        //console.log("Validacion app.js", res)
                        this.props.loadingState(true)
                        if (this.props.user.flagResetSecurityQuestions === 1) {
                            history.push('/questions')
                        } else {
                            if (this.props.user.flagResetPassword === 1) {
                                history.push('/password-change')
                            } else {
                                if (this.props.user.flagUsernameChange === 1) {
                                    history.push('/username-change')
                                }
                            }
                        }
                    }).catch(err => {
                        //console.log('error de carga ',err)
                        this.props.logoutAction()
                        this.props.resetStore()
                        this.props.loadingState(false)
                        history.push('/home')
                    })
                    //envia al dispositivo
                    let send = {
                        type: 'data',
                        data: payload
                    }
                    sendMobile(JSON.stringify(send))
                }
                !payload.user && history.push('/home')
            }).catch(error => {
                //console.log('error en loginSuccess ', error)
                history.push('/home')
            })

        } else {
            // console.log('redirige')
            // history.push('/home')
        }
    }

    renderCustomer = () => {
        const { credits, loading, deposits } = this.props
        return loading ?
            <CodesContainer
                classes={this.props}
                deposits={deposits}
                handleOpenSnack={this.handleOpenSnack}
                balances={this.props.balances}
                credits={credits} /> :
            <div></div>
    }

    renderBodyHomeInfoUserMobile = () => {
        if (!isEmpty(this.props.user2) && this.props.balances.length > 0) {

            return <HomeInfoUserMobile
                customer={this.props.user2}
                amount={this.props.balances[0].Saldo}
                accountType={`${this.props.balances[0].EstadoNombre} - ${this.props.balances[0].TipoCuentaNombre}`}
                authenticate={this.props.user}
                credits={this.props.credits}
                balances={this.props.balances[0]}
                chart={this.renderChart()}
            />

        } else {

            return <HomeInfoUserMobile skeleton={true} user={{}} />

        }
    }

    renderInfoDeviceUser = () => {
        const { user2, verificates, user, devices } = this.props;

        return <InfoDeviceUser
            customer={user2}
            devices={devices}
            verificates={verificates}
            user={user2}
            auth={user}
            handleOpenSnack={this.handleOpenSnack}
        />
    }

    renderInfoCustomer = () => {
        const { loading, verificates, parameters, getBalanceUser, consolidates, balances } = this.props
        return loading ?
            <CustomerContainer
                skeleton={false}
                classes={this.props}
                authenticate={this.props.user}
                balances={balances}
                balancesjoint={[]}
                user={this.props.user2}
                deposits={consolidates.depositosAPlazo}
                credits={consolidates.prestamos}
                /* creditsDetails={''} */
                verificates={verificates}
                parameters={parameters}
                getBalanceUser={getBalanceUser}
            // accountType = { `${this.props.balances[0].EstadoNombre} - ${this.props.balances[0].TipoCuentaNombre}` }
            /> :
            <CustomerContainer skeleton={true} classes={this.props} user={{}} />
    }
    renderChart = () => {
        return <div /* style={{backgroundColor: '#ffffff', borderRadius: "8px"}} */>
            {<Pie data={{ title: 'Consolidado de cuentas', data: this.dataChart() }} />}
        </div>
    }
    renderTaxes = (taxeType, title, taxetitle) => {
        const { user2, user, periodsCore, levelsCore, agreements, balances, parameters, devices, getDeviceData, updateIpDevice, agreementTypes } = this.props
        try {
            return <div>
                {
                    (user2 && balances.length > 0 && agreements.length > 0) ?
                        <AcademyTaxeContainer
                            taxeType={taxeType}
                            user={user2}
                            auth={user}
                            periods={periodsCore}
                            levels={levelsCore}
                            title={title}
                            taxetitle={taxetitle}
                            agreements={agreements.filter(agr => {
                                if (agr.type === taxeType)
                                    return true
                                else
                                    return false
                            })}
                            agreementType={filterArrayEqual(agreementTypes, 'id', taxeType)[0].state}
                            balances={filterArrayMoreEqual(balances, 'PRODUCTALIAS', ['DEPOSITOS A LA VISTA',])}
                            handleOpenSnack={this.handleOpenSnack}
                            parameters={parameters}
                            devices={devices}
                            getDeviceData={getDeviceData}
                            updateIpDevice={updateIpDevice}
                        /> :
                        <div>cargando</div>
                }
            </div>
        } catch (error) {
            //console.log('error de carga de renderTaxes ', error)
        }

    }
    // handle
    handleOncloseSnack = () => {
        this.setState({ openSnackbar: false });
    }
    handleOpenSnack = (message, type = 'error') => {
        //console.log(type)
        try {
            this.setState({ openSnackbar: true, message, type });
        } catch (error) {

        }
    }

    setOnLogoutClose = async () => {
        this.setState({ loading: true })
        let send = {
            type: 'data',
            data: 'logout'
        }
        sendMobile(JSON.stringify(send))
        await this.props.logoutAction()
        await this.props.resetStore()
        await this.props.loadingState(false)
    }

    setOnLogout = () => {
        // console.log('cierra')
        this.setState({ loading: false })
        let send = {
            type: 'data',
            data: 'logout'
        }
        sendMobile(JSON.stringify(send))
        this.props.logoutAction()
        this.props.resetStore()
        this.props.loadingState(false)
        history.push('/home')
    }

    onPatchedService = () => {
        // Receive real-time events through Socket.io

    }


    render() {



        const { user, devices, balances, /* consolidates, */
            authentication, notifications, certificates,
            deposits, credits, loading, parameters, quotas, getDeviceData, updateIpDevice, institutionsCore,
            entitiesCore, user2, agreementsSwitchServices, otherServices, complements, getDPFTypeDeposits, precalificacion, documentos, menuItems, getParametersTranviaServices } = this.props;
        // console.log('this.props', this.props)
        //console.log('maintenanceTime3', this.state.maintenanceTime)

        const valueIdle = filterArrayEqual(parameters, 'code', 'IDLE_TIME_ALLOWED').length > 0 ? parseInt(filterArrayEqual(parameters, 'code', 'IDLE_TIME_ALLOWED')[0].value) : 420000

        //console.log(valueIdle)
        //console.log(new Date())
        return (
            <div className="jumbotron">
                <div className="container">
                    <div className="col-sm-8 col-sm-offset-2">
                        <Dialog
                            // fullScreen={isMobile}
                            maxWidth="md"
                            open={this.state.popup}
                            onClose={() => this.closePopup()}
                        >
                            {isMobile ?
                                <img src={urlBase + "popup_movil.png"} alt='popup' />
                                :
                                <img src={urlBase + "popup.png"} alt='popup' />
                            }
                            <Button endIcon={<Close />} /* color='primary' */ variant='text' onClick={() => this.closePopup()} style={{ position: 'absolute', top: 0, right: 5 }} >Cerrar</Button>
                        </Dialog>
                        {/* your app here */}
                        {/* (this.state.maintenanceTime) ?
                            <ThemeProvider theme={themeLogin}>
                                <Router history={history}>
                                    <Switch>
                                        <Route path="/maintenance">
                                            <MaintenanceContainer handleOpenSnack={this.handleOpenSnack} getDeviceData={getDeviceData} devices={devices} updateIpDevice={updateIpDevice} />
                                        </Route>
                                        <Redirect from="*" to="/maintenance" />
                                    </Switch>
                                </Router>
                            </ThemeProvider>
                            : */
                            (localStorage.auth === undefined) ?
                                (this.state.maintenanceTime) ?
                                    <ThemeProvider theme={themeLogin}>
                                        <Router history={history}>
                                            <Switch>
                                                <Route path="/maintenance">
                                                    <MaintenanceContainer handleOpenSnack={this.handleOpenSnack} getDeviceData={getDeviceData} devices={devices} updateIpDevice={updateIpDevice} />
                                                </Route>
                                                <Redirect from="*" to="/maintenance" />
                                            </Switch>
                                        </Router>
                                    </ThemeProvider>
                                    :
                                    <ThemeProvider theme={themeLogin}>
                                        <Router history={history}>
                                            <Switch>
                                                <Route path="/home">
                                                    <HomeLogoutContainer
                                                        handleOpenSnack={this.handleOpenSnack}
                                                        getDeviceData={getDeviceData}
                                                        devices={devices}
                                                        updateIpDevice={updateIpDevice} />
                                                </Route>
                                                <Route path="/login">
                                                    <LoginPage
                                                        handleOpenSnack={this.handleOpenSnack}
                                                        getDeviceData={getDeviceData}
                                                        devices={devices}
                                                        updateIpDevice={updateIpDevice} ></LoginPage>
                                                </Route>
                                                <Route path="/password-recover">
                                                    <RecoverContainer
                                                        handleOpenSnack={this.handleOpenSnack}
                                                        recoveryType={11}
                                                        getDeviceData={getDeviceData}
                                                        devices={devices}
                                                        updateIpDevice={updateIpDevice} />
                                                </Route>
                                                <Route path="/user-recover">
                                                    <RecoverContainer
                                                        handleOpenSnack={this.handleOpenSnack}
                                                        recoveryType={12}
                                                        getDeviceData={getDeviceData}
                                                        devices={devices}
                                                        updateIpDevice={updateIpDevice} />
                                                </Route>
                                                <Route path="/user-unlock">
                                                    <RecoverContainer
                                                        handleOpenSnack={this.handleOpenSnack}
                                                        recoveryType={42}
                                                        getDeviceData={getDeviceData}
                                                        devices={devices}
                                                        updateIpDevice={updateIpDevice} />
                                                </Route>
                                                <Route path="/certificate-validate">
                                                    <CertificateValidateContainer
                                                        handleOpenSnack={this.handleOpenSnack}
                                                        getDeviceData={getDeviceData}
                                                        devices={devices}
                                                        updateIpDevice={updateIpDevice} />
                                                </Route>
                                                <Route path="/user-register" >
                                                    <UserRegisterContainer
                                                        /* user={this.props.user2}
                                                        customers={this.props.customers} */
                                                        handleOpenSnack={this.handleOpenSnack} />
                                                    {/* {
                                                            <Can
                                                                role={user.type}
                                                                perform="users:create"
                                                                yes={() => (
                                                                    user &&
                                                                    <UserRegisterContainer
                                                                        user={this.props.user2}
                                                                        customers={this.props.customers}
                                                                        handleOpenSnack={this.handleOpenSnack} />
                                                                )}
                                                                no={() => <Redirect to="/" />}
                                                            />
                                                        } */}
                                                </Route>
                                                {/*  <Route path="/maintenance">
                                                <MaintenanceContainer handleOpenSnack={this.handleOpenSnack} getDeviceData={getDeviceData} devices={devices} updateIpDevice={updateIpDevice} />
                                            </Route> */}
                                                <Redirect from="*" to="/home" />
                                            </Switch>
                                        </Router>
                                        {/* <CssBaseline />
                                    <ToolbarLogout
                                        renderContainer={
                                            <Router history={history}>
                                                <Switch>
                                                    <Route path="/home">
                                                        <HomeLogoutContainer handleOpenSnack={this.handleOpenSnack} getDeviceData={getDeviceData} devices={devices} updateIpDevice={updateIpDevice} />
                                                    </Route>
                                                    <Route path="/login">
                                                        <LoginPage handleOpenSnack={this.handleOpenSnack} getDeviceData={getDeviceData} devices={devices} updateIpDevice={updateIpDevice} ></LoginPage>
                                                    </Route>
                                                    <Route path="/password-recover">
                                                        <RecoverContainer handleOpenSnack={this.handleOpenSnack} recoveryType={false} getDeviceData={getDeviceData} devices={devices} updateIpDevice={updateIpDevice} />
                                                    </Route>
                                                    <Route path="/user-recover">
                                                        <RecoverContainer handleOpenSnack={this.handleOpenSnack} recoveryType={true} getDeviceData={getDeviceData} devices={devices} updateIpDevice={updateIpDevice} />
                                                    </Route>
                                                    <Route path="/certificate-validate">
                                                        <CertificateValidateContainer handleOpenSnack={this.handleOpenSnack} getDeviceData={getDeviceData} devices={devices} updateIpDevice={updateIpDevice} />
                                                    </Route>
                                                    <Redirect from="*" to="/home" />
                                                </Switch>
                                            </Router>
                                        }
                                    /> */}
                                    </ThemeProvider> :
                                (authentication.user !== undefined) &&
                                <ThemeProvider theme={themePrimary("", this.state.isDark)}>
                                    <ToolBar
                                        menuItems={menuItems.info}
                                        pathCurrent={history.location}
                                        onLogout={this.setOnLogout}
                                        onNotification={this.fetchFromRemote}
                                        notifications={notifications}
                                        userState={user.flagResetPassword}
                                        userQuestions={user.flagResetSecurityQuestions}
                                        identificationUser={user.identification}
                                        parameters={parameters}
                                        setOnLogoutClose={this.setOnLogoutClose}
                                        devices={devices}
                                        userDatePassword={user.nextDateChangePassword}
                                        handleOpenSnack={this.handleOpenSnack}
                                        usernameChange={user.flagUsernameChange}
                                        handleDarkTheme={this.handleDarkTheme}
                                        isDark={this.state.isDark}
                                        timeSession={
                                            <IdleTimer
                                                ref={ref => { this.idleTimer = ref }}
                                                //element={document}
                                                onActive={this.onActive}
                                                onIdle={this.onIdle}
                                                onAction={this.onAction}
                                                debounce={250}
                                                timeout={valueIdle}
                                            />
                                        }
                                        renderContainer={
                                            <Router history={history}>
                                                <Switch >
                                                    <PrivateRoute exact path="/" >
                                                        <HomePage
                                                            loading={loading}
                                                            user={user}
                                                            renderBody={this.renderInfoDeviceUser()}
                                                            handleOpenSnack={this.handleOpenSnack}
                                                            renderInfoBody={this.renderChart()}
                                                            renderChart={this.renderInfoCustomer()}
                                                            multiple={true}
                                                        />
                                                    </PrivateRoute>

                                                    <PrivateRoute exact path="/username-change" >
                                                        <UsernameChangeContainer
                                                            parameters={parameters}
                                                            handleOpenSnack={this.handleOpenSnack}
                                                            devices={devices}
                                                            auth={this.props.user}
                                                        />
                                                    </PrivateRoute>

                                                    <PrivateRoute exact path="/account-administration" >
                                                        <AccountAdministrationContainer
                                                            parameters={parameters}
                                                            handleOpenSnack={this.handleOpenSnack}
                                                            devices={devices}
                                                            auth={this.props.user}
                                                        />
                                                    </PrivateRoute>
                                                    <Route exact path="/option-transfers" >
                                                        {
                                                            (user && balances.length > 0) &&
                                                            <TransferOptionsContainer
                                                                user={this.props.user2}
                                                                auth={this.props.user}
                                                                beneficiaries={this.props.beneficiary}
                                                                balances={filterArrayEqual(filterArrayMoreEqual(balances, 'PRODUCTALIAS', ['AHORRO VISTA']), "StatusId", 1)}
                                                                entities={entitiesCore}
                                                                institutions={institutionsCore}
                                                                handleOpenSnack={this.handleOpenSnack}
                                                                parameters={parameters}
                                                                quotas={quotas}
                                                                getQuotas={this.props.getQuotas}
                                                                getDeviceData={getDeviceData}
                                                                devices={devices}
                                                                updateIpDevice={updateIpDevice}
                                                                typeBeneficiaries={"PROPIA"}
                                                            />
                                                        }
                                                    </Route>
                                                    <Route exact path="/own-transfers" >
                                                        {
                                                            (user && balances.length > 0) &&
                                                            <TransfersOwnContainer
                                                                user={this.props.user2}
                                                                auth={this.props.user}
                                                                beneficiaries={this.props.beneficiary}
                                                                balances={filterArrayMoreEqual(balances, 'PRODUCTALIAS', ['AHORROS A LA VISTA'])}
                                                                entities={entitiesCore}
                                                                institutions={institutionsCore}
                                                                handleOpenSnack={this.handleOpenSnack}
                                                                parameters={parameters}
                                                                quotas={quotas}
                                                                getQuotas={this.props.getQuotas}
                                                                getDeviceData={getDeviceData}
                                                                devices={devices}
                                                                updateIpDevice={updateIpDevice}
                                                                typeBeneficiaries={"PROPIA"}
                                                            />
                                                        }
                                                    </Route>
                                                    <Route exact path="/internal-transfers" >
                                                        {
                                                            (user && balances.length > 0) &&
                                                            <TransfersInternalContainer
                                                                user={this.props.user2}
                                                                auth={this.props.user}
                                                                beneficiaries={this.props.beneficiary}
                                                                balances={filterArrayMoreEqual(balances, 'PRODUCTALIAS', ['AHORROS A LA VISTA',])}
                                                                entities={entitiesCore}
                                                                institutions={institutionsCore}
                                                                handleOpenSnack={this.handleOpenSnack}
                                                                parameters={parameters}
                                                                quotas={quotas}
                                                                getQuotas={this.props.getQuotas}
                                                                getDeviceData={getDeviceData}
                                                                devices={devices}
                                                                updateIpDevice={updateIpDevice}
                                                                typeBeneficiaries={"INTERNO"}
                                                            />
                                                        }
                                                    </Route>
                                                    <Route exact path="/external-transfers" >
                                                        {
                                                            (user && balances.length > 0) &&
                                                            <TransfersExternalContainer
                                                                user={this.props.user2}
                                                                auth={this.props.user}
                                                                beneficiaries={this.props.beneficiary}
                                                                balances={filterArrayMoreEqual(balances, 'PRODUCTALIAS', ['AHORROS A LA VISTA',])}
                                                                entities={entitiesCore}
                                                                institutions={institutionsCore}
                                                                handleOpenSnack={this.handleOpenSnack}
                                                                parameters={parameters}
                                                                quotas={quotas}
                                                                getQuotas={this.props.getQuotas}
                                                                getDeviceData={getDeviceData}
                                                                devices={devices}
                                                                updateIpDevice={updateIpDevice}
                                                                typeBeneficiaries={"EXTERNO"}
                                                            />
                                                        }
                                                    </Route>
                                                    <Route exact path="/credit-card-payment" >
                                                        {
                                                            (user && balances.length > 0) &&
                                                            <CreditCardPaymentContainer
                                                                user={this.props.user2}
                                                                auth={this.props.user}
                                                                beneficiaries={this.props.beneficiary}
                                                                balances={filterArrayMoreEqual(balances, 'PRODUCTALIAS', ['AHORROS A LA VISTA',])}
                                                                entities={entitiesCore}
                                                                institutions={institutionsCore}
                                                                handleOpenSnack={this.handleOpenSnack}
                                                                parameters={parameters}
                                                                quotas={quotas}
                                                                getQuotas={this.props.getQuotas}
                                                                getDeviceData={getDeviceData}
                                                                devices={devices}
                                                                updateIpDevice={updateIpDevice}
                                                            />
                                                        }
                                                    </Route>
                                                    <Route exact path="/qr-generate" >
                                                        {
                                                            (user && balances.length > 0) &&
                                                            <QrGeneratesContainer
                                                                user={this.props.user2}
                                                                auth={this.props.user}
                                                                //getBalanceUser = {getBalanceUser}
                                                                classes={this.props}
                                                                handleOpenSnack={this.handleOpenSnack}
                                                                balances={filterArrayMoreEqual(balances, 'PRODUCTALIAS', ['AHORROS A LA VISTA',])}
                                                                parameters={parameters}
                                                                devices={devices}
                                                                //sendEmailWithVoucher = {sendEmailWithVoucher}
                                                                updateIpDevice={updateIpDevice}
                                                                getDeviceData={getDeviceData}
                                                            />
                                                        }
                                                    </Route>
                                                    <Route exact path="/password-change" >
                                                        {
                                                            user &&
                                                            <PasswordChangeContainer
                                                                user={this.props.user}
                                                                handleOpenSnack={this.handleOpenSnack}
                                                                parameters={parameters}
                                                                getDeviceData={getDeviceData}
                                                                devices={devices}
                                                                updateIpDevice={updateIpDevice}
                                                            />
                                                        }
                                                    </Route>
                                                    <Route exact path="/change-quotas" >
                                                        {
                                                            user &&
                                                            <ChangeQuotasContainer
                                                                user={this.props.user}
                                                                handleOpenSnack={this.handleOpenSnack}
                                                                parameters={parameters}
                                                                quotas={quotas}
                                                                devices={devices}
                                                            />
                                                        }
                                                    </Route>
                                                    <Route exact path="/questions" >
                                                        {
                                                            user &&
                                                            <QuestionsContainer
                                                                user={this.props.user}
                                                                handleOpenSnack={this.handleOpenSnack}
                                                                parameters={parameters}
                                                                usercore={this.props.user2}
                                                                getDeviceData={getDeviceData}
                                                                devices={devices}
                                                                updateIpDevice={updateIpDevice}
                                                            />
                                                        }
                                                    </Route>
                                                    <Route exact path="/option-payments" >
                                                        {
                                                            (user && balances.length > 0) &&
                                                            <PaymentOptionsContainer
                                                                user={this.props.user2}
                                                                auth={this.props.user}
                                                                beneficiaries={this.props.beneficiary}
                                                                balances={filterArrayMoreEqual(balances, 'PRODUCTALIAS', ['AHORROS A LA VISTA',])}
                                                                entities={entitiesCore}
                                                                institutions={institutionsCore}
                                                                handleOpenSnack={this.handleOpenSnack}
                                                                parameters={parameters}
                                                                quotas={quotas}
                                                                getQuotas={this.props.getQuotas}
                                                                getDeviceData={getDeviceData}
                                                                devices={devices}
                                                                updateIpDevice={updateIpDevice}
                                                                typeBeneficiaries={"PROPIA"}
                                                                menuItems={menuItems.info}
                                                            />
                                                        }
                                                    </Route>
                                                    <Route exact path="/electronic-recharges" >
                                                        {
                                                            (user2 && balances.length > 0) &&
                                                            <ElectronicRechargesContainer
                                                                user={user2}
                                                                balances={filterArrayMoreEqual(balances, 'PRODUCTALIAS', ['AHORROS A LA VISTA',])}
                                                                handleOpenSnack={this.handleOpenSnack}
                                                                parameters={parameters}
                                                                auth={user}
                                                                getDeviceData={getDeviceData}
                                                                devices={devices}
                                                                updateIpDevice={updateIpDevice}
                                                                agreementsSwitchServices={filterArrayEqual(agreementsSwitchServices, 'category', 'RECARGAS')}
                                                                otherServices={otherServices}
                                                                allAgreementsSwicthServices={agreementsSwitchServices}
                                                            />
                                                        }
                                                    </Route>
                                                    <Route exact path="/plan-payment" >
                                                        {
                                                            (user2 && balances.length > 0) &&
                                                            <PaymentServiceSwitchContainer
                                                                user={user2}
                                                                balances={filterArrayMoreEqual(balances, 'PRODUCTALIAS', ['AHORROS A LA VISTA',])}
                                                                handleOpenSnack={this.handleOpenSnack}
                                                                parameters={parameters}
                                                                auth={user}
                                                                getDeviceData={getDeviceData}
                                                                devices={devices}
                                                                updateIpDevice={updateIpDevice}
                                                                agreementsSwitchServices={filterArrayEqual(agreementsSwitchServices, 'category', 'PLANES')}
                                                                type={"PLANES"}
                                                                titleUrl={"Planes"}
                                                                otherServices={otherServices}
                                                                identityAgreement={""}
                                                                titleOptionOneMenu={"Seleccione un número de referencia favorita"}
                                                                titleOptionTwoMenu={"Agregar un nuevo número de referencia"}
                                                                allAgreementsSwicthServices={agreementsSwitchServices}
                                                            />
                                                        }
                                                    </Route>
                                                    <Route exact path="/electricity-payment" >
                                                        {
                                                            (user2 && balances.length > 0) &&
                                                            <PaymentServiceSwitchContainer
                                                                user={user2}
                                                                balances={filterArrayMoreEqual(balances, 'PRODUCTALIAS', ['AHORROS A LA VISTA',])}
                                                                handleOpenSnack={this.handleOpenSnack}
                                                                parameters={parameters}
                                                                auth={user}
                                                                getDeviceData={getDeviceData}
                                                                devices={devices}
                                                                updateIpDevice={updateIpDevice}
                                                                agreementsSwitchServices={filterArrayEqual(agreementsSwitchServices, 'category', 'LUZ')}
                                                                type={"LUZ"}
                                                                titleUrl={"Luz"}
                                                                otherServices={otherServices}
                                                                identityAgreement={""}
                                                                titleOptionOneMenu={"Seleccione un número de referencia favorita"}
                                                                titleOptionTwoMenu={"Agregar un nuevo número de referencia"}
                                                                allAgreementsSwicthServices={agreementsSwitchServices}
                                                            />
                                                        }
                                                    </Route>
                                                    <Route exact path="/telephone-payment" >
                                                        {
                                                            (user2 && balances.length > 0) &&
                                                            <PaymentServiceSwitchContainer
                                                                user={user2}
                                                                balances={filterArrayMoreEqual(balances, 'PRODUCTALIAS', ['AHORROS A LA VISTA',])}
                                                                handleOpenSnack={this.handleOpenSnack}
                                                                parameters={parameters}
                                                                auth={user}
                                                                getDeviceData={getDeviceData}
                                                                devices={devices}
                                                                updateIpDevice={updateIpDevice}
                                                                agreementsSwitchServices={filterArrayEqual(agreementsSwitchServices, 'category', 'TELEFONO')}
                                                                type={"TELEFONO"}
                                                                titleUrl={"Telefonia Fija"}
                                                                otherServices={otherServices}
                                                                identityAgreement={""}
                                                                titleOptionOneMenu={"Seleccione un número de referencia favorita"}
                                                                titleOptionTwoMenu={"Agregar un nuevo número de referencia"}
                                                                allAgreementsSwicthServices={agreementsSwitchServices}
                                                            />
                                                        }
                                                    </Route>
                                                    <Route exact path="/water-payment" >
                                                        {
                                                            (user2 && balances.length > 0) &&
                                                            <PaymentServiceSwitchContainer
                                                                user={user2}
                                                                balances={filterArrayMoreEqual(balances, 'PRODUCTALIAS', ['AHORROS A LA VISTA',])}
                                                                handleOpenSnack={this.handleOpenSnack}
                                                                parameters={parameters}
                                                                auth={user}
                                                                getDeviceData={getDeviceData}
                                                                devices={devices}
                                                                updateIpDevice={updateIpDevice}
                                                                agreementsSwitchServices={filterArrayEqual(agreementsSwitchServices, 'category', 'AGUA')}
                                                                type={"AGUA"}
                                                                titleUrl={"Agua"}
                                                                otherServices={otherServices}
                                                                identityAgreement={""}
                                                                titleOptionOneMenu={"Seleccione un número de referencia favorita"}
                                                                titleOptionTwoMenu={"Agregar un nuevo número de referencia"}
                                                                allAgreementsSwicthServices={agreementsSwitchServices}
                                                            />
                                                        }
                                                    </Route>
                                                    <Route exact path="/catalog-payment" >
                                                        {
                                                            (user2 && balances.length > 0) &&
                                                            <PaymentServiceSwitchContainer
                                                                user={user2}
                                                                balances={filterArrayMoreEqual(balances, 'PRODUCTALIAS', ['AHORROS A LA VISTA',])}
                                                                handleOpenSnack={this.handleOpenSnack}
                                                                parameters={parameters}
                                                                auth={user}
                                                                getDeviceData={getDeviceData}
                                                                devices={devices}
                                                                updateIpDevice={updateIpDevice}
                                                                agreementsSwitchServices={filterArrayEqual(agreementsSwitchServices, 'category', 'CATALOGO')}
                                                                type={"CATALOGO"}
                                                                titleUrl={"CATALOGO REVISTAS"}
                                                                otherServices={otherServices}
                                                                identityAgreement={""}
                                                                titleOptionOneMenu={"Seleccione un número de referencia favorita"}
                                                                titleOptionTwoMenu={"Agregar un nuevo número de referencia"}
                                                                allAgreementsSwicthServices={agreementsSwitchServices}
                                                            />
                                                        }
                                                    </Route>

                                                    <Route exact path="/iess" >
                                                        {
                                                            (user2 && balances.length > 0) &&
                                                            <PaymentServiceSwitchContainer
                                                                user={user2}
                                                                balances={filterArrayMoreEqual(balances, 'PRODUCTALIAS', ['AHORROS A LA VISTA',])}
                                                                handleOpenSnack={this.handleOpenSnack}
                                                                parameters={parameters}
                                                                auth={user}
                                                                getDeviceData={getDeviceData}
                                                                devices={devices}
                                                                updateIpDevice={updateIpDevice}
                                                                agreementsSwitchServices={filterArrayEqual(agreementsSwitchServices, 'category', 'IESS')}
                                                                type={"IESS"}
                                                                titleUrl={"IESS"}
                                                                otherServices={otherServices}
                                                                identityAgreement={""}
                                                                titleOptionOneMenu={"Seleccione un número de referencia favorita"}
                                                                titleOptionTwoMenu={"Agregar un nuevo número de referencia"}
                                                                allAgreementsSwicthServices={agreementsSwitchServices}
                                                            />
                                                        }
                                                    </Route>

                                                    <Route exact path="/sri" >
                                                        {
                                                            (user2 && balances.length > 0) &&
                                                            <PaymentServiceSwitchContainer
                                                                user={user2}
                                                                balances={filterArrayMoreEqual(balances, 'PRODUCTALIAS', ['AHORROS A LA VISTA',])}
                                                                handleOpenSnack={this.handleOpenSnack}
                                                                parameters={parameters}
                                                                auth={user}
                                                                getDeviceData={getDeviceData}
                                                                devices={devices}
                                                                updateIpDevice={updateIpDevice}
                                                                agreementsSwitchServices={filterArrayEqual(agreementsSwitchServices, 'category', 'SRI')}
                                                                type={"SRI"}
                                                                titleUrl={"SRI"}
                                                                otherServices={otherServices}
                                                                identityAgreement={""}
                                                                titleOptionOneMenu={"Seleccione un número de referencia favorita"}
                                                                titleOptionTwoMenu={"Agregar un nuevo número de referencia"}
                                                                allAgreementsSwicthServices={agreementsSwitchServices}
                                                            />
                                                        }
                                                    </Route>



                                                    <Route exact path="/transit" >
                                                        {
                                                            (user2 && balances.length > 0) &&
                                                            <PaymentServiceSwitchContainer
                                                                user={user2}
                                                                balances={filterArrayMoreEqual(balances, 'PRODUCTALIAS', ['AHORROS A LA VISTA',])}
                                                                handleOpenSnack={this.handleOpenSnack}
                                                                parameters={parameters}
                                                                auth={user}
                                                                getDeviceData={getDeviceData}
                                                                devices={devices}
                                                                updateIpDevice={updateIpDevice}
                                                                agreementsSwitchServices={filterArrayEqual(agreementsSwitchServices, 'category', 'TRANSITO')}
                                                                type={"TRANSITO"}
                                                                titleUrl={"TRANSITO"}
                                                                otherServices={otherServices}
                                                                identityAgreement={""}
                                                                titleOptionOneMenu={"Seleccione un número de referencia favorita"}
                                                                titleOptionTwoMenu={"Agregar un nuevo número de referencia"}
                                                                allAgreementsSwicthServices={agreementsSwitchServices}
                                                            />
                                                        }
                                                    </Route>

                                                    <Route exact path="/municipalities" >
                                                        {
                                                            (user2 && balances.length > 0) &&
                                                            <PaymentServiceSwitchContainer
                                                                user={user2}
                                                                balances={filterArrayMoreEqual(balances, 'PRODUCTALIAS', ['AHORROS A LA VISTA',])}
                                                                handleOpenSnack={this.handleOpenSnack}
                                                                parameters={parameters}
                                                                auth={user}
                                                                getDeviceData={getDeviceData}
                                                                devices={devices}
                                                                updateIpDevice={updateIpDevice}
                                                                agreementsSwitchServices={filterArrayEqual(agreementsSwitchServices, 'category', 'MUNICIPIO')}
                                                                type={"MUNICIPIO"}
                                                                titleUrl={"MUNICIPIO"}
                                                                otherServices={otherServices}
                                                                identityAgreement={""}
                                                                titleOptionOneMenu={"Seleccione un número de referencia favorita"}
                                                                titleOptionTwoMenu={"Agregar un nuevo número de referencia"}
                                                                allAgreementsSwicthServices={agreementsSwitchServices}
                                                            />
                                                        }
                                                    </Route>
                                                    <Route exact path="/internet" >
                                                        {
                                                            (user2 && balances.length > 0) &&
                                                            <PaymentServiceSwitchContainer
                                                                user={user2}
                                                                balances={filterArrayMoreEqual(balances, 'PRODUCTALIAS', ['AHORROS A LA VISTA',])}
                                                                handleOpenSnack={this.handleOpenSnack}
                                                                parameters={parameters}
                                                                auth={user}
                                                                getDeviceData={getDeviceData}
                                                                devices={devices}
                                                                updateIpDevice={updateIpDevice}
                                                                agreementsSwitchServices={filterArrayEqual(agreementsSwitchServices, 'category', 'INTERNET')}
                                                                type={"INTERNET"}
                                                                titleUrl={"INTERNET"}
                                                                otherServices={otherServices}
                                                                identityAgreement={""}
                                                                titleOptionOneMenu={"Seleccione un número de referencia favorita"}
                                                                titleOptionTwoMenu={"Agregar un nuevo número de referencia"}
                                                                allAgreementsSwicthServices={agreementsSwitchServices}
                                                            />
                                                        }
                                                    </Route>

                                                    <Route exact path="/others" >
                                                        {
                                                            (user2 && balances.length > 0) &&
                                                            <PaymentServiceSwitchContainer
                                                                user={user2}
                                                                balances={filterArrayMoreEqual(balances, 'PRODUCTALIAS', ['AHORROS A LA VISTA',])}
                                                                handleOpenSnack={this.handleOpenSnack}
                                                                parameters={parameters}
                                                                auth={user}
                                                                getDeviceData={getDeviceData}
                                                                devices={devices}
                                                                updateIpDevice={updateIpDevice}
                                                                agreementsSwitchServices={filterArrayEqual(agreementsSwitchServices, 'category', 'VARIOS')}
                                                                type={"VARIOS"}
                                                                titleUrl={"VARIOS"}
                                                                otherServices={otherServices}
                                                                identityAgreement={""}
                                                                titleOptionOneMenu={"Seleccione un número de referencia favorita"}
                                                                titleOptionTwoMenu={"Agregar un nuevo número de referencia"}
                                                                allAgreementsSwicthServices={agreementsSwitchServices}
                                                            />
                                                        }
                                                    </Route>

                                                    <Route exact path="/shops" >
                                                        {
                                                            (user2 && balances.length > 0) &&
                                                            <PaymentServiceSwitchContainer
                                                                user={user2}
                                                                balances={filterArrayMoreEqual(balances, 'PRODUCTALIAS', ['AHORROS A LA VISTA',])}
                                                                handleOpenSnack={this.handleOpenSnack}
                                                                parameters={parameters}
                                                                auth={user}
                                                                getDeviceData={getDeviceData}
                                                                devices={devices}
                                                                updateIpDevice={updateIpDevice}
                                                                agreementsSwitchServices={filterArrayEqual(agreementsSwitchServices, 'category', 'COMERCIOS')}
                                                                type={"COMERCIOS"}
                                                                titleUrl={"COMERCIOS"}
                                                                otherServices={otherServices}
                                                                identityAgreement={""}
                                                                titleOptionOneMenu={"Seleccione un número de referencia favorita"}
                                                                titleOptionTwoMenu={"Agregar un nuevo número de referencia"}
                                                                allAgreementsSwicthServices={agreementsSwitchServices}
                                                            />
                                                        }
                                                    </Route>

                                                    <Route exact path="/judiciary-council" >
                                                        {
                                                            (user2 && balances.length > 0) &&
                                                            <PaymentServiceSwitchSupaContainer
                                                                user={user2}
                                                                balances={filterArrayMoreEqual(balances, 'PRODUCTALIAS', ['AHORROS A LA VISTA',])}
                                                                handleOpenSnack={this.handleOpenSnack}
                                                                parameters={parameters}
                                                                auth={user}
                                                                getDeviceData={getDeviceData}
                                                                devices={devices}
                                                                updateIpDevice={updateIpDevice}
                                                                agreementsSwitchServices={filterArrayEqual(agreementsSwitchServices, 'category', 'COMERCIOS')}
                                                                type={"COMERCIOS"}
                                                                titleUrl={"COMERCIOS"}
                                                                otherServices={otherServices}
                                                                identityAgreement={""}
                                                                titleOptionOneMenu={"Seleccione un número de referencia favorita"}
                                                                titleOptionTwoMenu={"Agregar un nuevo número de referencia"}
                                                                allAgreementsSwicthServices={agreementsSwitchServices}
                                                            />
                                                        }
                                                    </Route>

                                                    <Route exact path="/cards" >
                                                        {
                                                            (user2 && balances.length > 0) &&
                                                            <PaymentServiceSwitchContainer
                                                                user={user2}
                                                                balances={filterArrayMoreEqual(balances, 'PRODUCTALIAS', ['AHORROS A LA VISTA',])}
                                                                handleOpenSnack={this.handleOpenSnack}
                                                                parameters={parameters}
                                                                auth={user}
                                                                getDeviceData={getDeviceData}
                                                                devices={devices}
                                                                updateIpDevice={updateIpDevice}
                                                                agreementsSwitchServices={filterArrayEqual(agreementsSwitchServices, 'category', 'TARJETA')}
                                                                type={"TARJETAS"}
                                                                titleUrl={"TARJETAS"}
                                                                otherServices={otherServices}
                                                                identityAgreement={""}
                                                                titleOptionOneMenu={"Seleccione un número de referencia favorita"}
                                                                titleOptionTwoMenu={"Agregar un nuevo número de referencia"}
                                                                allAgreementsSwicthServices={agreementsSwitchServices}
                                                            />
                                                        }
                                                    </Route>

                                                    <Route exact path="/movements/:id"
                                                        render={props => <MovementsContainer
                                                            classes={this.props}
                                                            secuencial={props.match.params.id}
                                                            parameters={parameters}
                                                            //mandamos el usuario para que se pueda hacer el filtro de los movimientos
                                                            user={user2}
                                                        />}
                                                    >
                                                    </Route>
                                                    <Route exact path="/movements-deposits/:id"
                                                        render={props => {
                                                            if (loading) {
                                                                return <DepositsContainer
                                                                    classes={this.props}
                                                                    deposits={deposits}
                                                                    secuencial={props.match.params.id}
                                                                    balances={balances}
                                                                    parameters={parameters} />
                                                            } else return <div>cargando...</div>
                                                        }}
                                                    ></Route>
                                                    <Route exact path="/movements-credits/:id"
                                                        render={props => <CreditsContainer
                                                            classes={this.props}
                                                            credits={credits}
                                                            secuencial={props.match.params.id}
                                                            parameters={parameters}
                                                            balances={balances} />}
                                                    ></Route>
                                                    <Route exact path="/vouchers-transfert" >
                                                        {
                                                            (loading) ?
                                                                <VoucherTransfertContainer
                                                                    user={user2}
                                                                    auth={user}
                                                                    classes={this.props}
                                                                    handleOpenSnack={this.handleOpenSnack}
                                                                    balances={filterArrayMoreEqual(balances, 'PRODUCTALIAS', ['AHORROS A LA VISTA',])}
                                                                    parameters={parameters}
                                                                /> :
                                                                <div>cargando...</div>
                                                        }
                                                    </Route>
                                                    <Route exact path="/vouchers-service-pay" >
                                                        {
                                                            (loading) ?
                                                                <VoucherServicePayContainer
                                                                    user={user2}
                                                                    classes={this.props}
                                                                    handleOpenSnack={this.handleOpenSnack}
                                                                    balances={filterArrayMoreEqual(balances, 'PRODUCTALIAS', ['AHORROS A LA VISTA',])}
                                                                    parameters={parameters}
                                                                /> :
                                                                <div>cargando...</div>
                                                        }
                                                    </Route>
                                                    <Route exact path="/vouchers-credit-card-payment" >
                                                        {
                                                            (loading) ?
                                                                <VoucherCreditCardPaymentContainer
                                                                    user={user2}
                                                                    classes={this.props}
                                                                    handleOpenSnack={this.handleOpenSnack}
                                                                    balances={filterArrayMoreEqual(balances, 'PRODUCTALIAS', ['AHORROS A LA VISTA',])}
                                                                    parameters={parameters}
                                                                /> :
                                                                <div>cargando...</div>
                                                        }
                                                    </Route>
                                                    <Route exact path="/vouchers-qr-payment" >
                                                        {
                                                            (loading) ?
                                                                <VouchersQrPayment
                                                                    user={user2}
                                                                    auth={user}
                                                                    classes={this.props}
                                                                    handleOpenSnack={this.handleOpenSnack}
                                                                    balances={filterArrayMoreEqual(balances, 'PRODUCTALIAS', ['AHORROS A LA VISTA',])}
                                                                    parameters={parameters}
                                                                /> :
                                                                <div>cargando...</div>
                                                        }
                                                    </Route>
                                                    <Route exact path="/credit-request-test" >
                                                        {
                                                            (loading) ?
                                                                <CreditRequestTestContainer
                                                                    dpfTypesDeposits={complements.dpfTypesDeposits === undefined ? [] : complements.dpfTypesDeposits}
                                                                    getDPFTypeDeposits={getDPFTypeDeposits}
                                                                    parameters={parameters}
                                                                    user={user2}
                                                                    auth={user}
                                                                    balances={filterArrayMoreEqual(balances, 'PRODUCTALIAS', ['AHORROS A LA VISTA',])}
                                                                    classes={this.props}
                                                                    handleOpenSnack={this.handleOpenSnack}
                                                                    getDeviceData={getDeviceData}
                                                                    updateIpDevice={updateIpDevice}
                                                                    devices={devices}
                                                                    precalificacion={precalificacion}
                                                                    documentos={documentos}
                                                                // balances = {orderAccountsVouchers(balances)}
                                                                /> :
                                                                <div>cargando...</div>
                                                        }
                                                        {/* {
                                                            (user && balances.length > 0) &&
                                                            <TransfersExternalContainer
                                                                user={this.props.user2}
                                                                auth={this.props.user}
                                                                beneficiaries={this.props.beneficiary}
                                                                balances={filterArrayMoreEqual(balances, 'PRODUCTALIAS', ['AHORROS A LA VISTA',])}
                                                                entities={entitiesCore}
                                                                institutions={institutionsCore}
                                                                handleOpenSnack={this.handleOpenSnack}
                                                                parameters={parameters}
                                                                quotas={quotas}
                                                                getQuotas={this.props.getQuotas}
                                                                getDeviceData={getDeviceData}
                                                                devices={devices}
                                                                updateIpDevice={updateIpDevice}
                                                                typeBeneficiaries={"EXTERNO"}
                                                            />
                                                        } */}
                                                    </Route>
                                                    {/* <Route exact path="/qr-generate" >
                                                        {
                                                            (user && balances.length > 0) &&
                                                            <QrGeneratesContainer
                                                                user={user2}
                                                                auth={user}
                                                                //getBalanceUser = {getBalanceUser}
                                                                classes={this.props}
                                                                handleOpenSnack={this.handleOpenSnack}
                                                                balances={filterArrayMoreEqual(balances, 'PRODUCTALIAS', ['AHORROS A LA VISTA',])}
                                                                parameters={parameters}
                                                                devices={devices}
                                                                //sendEmailWithVoucher = {sendEmailWithVoucher}
                                                                updateIpDevice={updateIpDevice}
                                                                getDeviceData={getDeviceData}
                                                            />
                                                        }
                                                    </Route> */}
                                                    <Route exact path="/report-qr" >
                                                        {
                                                            (user && balances.length > 0) &&
                                                            <ReportQr
                                                                devices={devices}
                                                                handleOpenSnack={this.handleOpenSnack}
                                                            />
                                                        }
                                                    </Route>
                                                    <Route exact path="/credits-pay" >
                                                        {
                                                            (loading) ?
                                                                <CreditsPayContainer
                                                                    auth={user}
                                                                    user={user2}
                                                                    balances={filterArrayMoreEqual(balances, 'PRODUCTALIAS', ['AHORROS A LA VISTA',])}
                                                                    credits={credits}
                                                                    handleOpenSnack={this.handleOpenSnack}
                                                                    parameters={parameters}
                                                                    getDeviceData={getDeviceData}
                                                                    updateIpDevice={updateIpDevice}
                                                                    devices={devices}
                                                                /> :
                                                                <div>cargando...</div>
                                                        }
                                                    </Route>
                                                    {/*
                                        <Route exact path = "/vouchers-transfert" >
                                            {
                                                (loading) ?
                                                    <VoucherTransfertContainer
                                                        user = { user2 }
                                                        classes = { this.props }
                                                        handleOpenSnack = { this.handleOpenSnack }
                                                        balances = {filterArrayMoreEqual(balances, 'Tipo', ['AHORRO', 'CORRESPONSALIA'])}
                                                    /> :
                                                    <div>cargando...</div>
                                            }
                                        </Route>
                                        <Route exact path = "/vouchers-credits-pay" >
                                            {
                                                (loading) ?
                                                    <VoucherCreditsPayContainer
                                                        user = { user2 }
                                                        classes = { this.props }
                                                        handleOpenSnack = { this.handleOpenSnack }
                                                        balances = {filterArrayMoreEqual(balances, 'Tipo', ['AHORRO', 'CORRESPONSALIA'])}
                                                    /> :
                                                    <div>cargando...</div>
                                            }
                                        </Route>
                                        <Route exact path = "/vouchers-service-pay" >
                                            {
                                                (loading) ?
                                                    <VoucherServicePayContainer
                                                        user = { user2 }
                                                        classes = { this.props }
                                                        handleOpenSnack = { this.handleOpenSnack }
                                                        balances = {orderAccountsVouchers(balances)}
                                                    /> :
                                                    <div>cargando...</div>
                                            }
                                        </Route>
                                        <Route exact path = "/vouchers-payment-meter" >
                                            {
                                                (loading) ?
                                                    <VoucherPaymentMeterContainer
                                                        user = { user2 }
                                                        classes = { this.props }
                                                        handleOpenSnack = { this.handleOpenSnack }
                                                        balances = {orderAccountsVouchers(balances)}
                                                    /> :
                                                    <div>cargando...</div>
                                            }
                                        </Route> */}
                                                    <Route exact path="/certificates" >
                                                        {
                                                            (loading) ?
                                                                <CertificatesContainer
                                                                    getCertificatesCore={this.getCertificatesCore}
                                                                    certificates={certificates}
                                                                    user={user2}
                                                                    auth={user}
                                                                    classes={this.props}
                                                                    handleOpenSnack={this.handleOpenSnack}
                                                                    balances={filterArrayMoreEqual(balances, 'PRODUCTALIAS', ['AHORROS A LA VISTA',])}
                                                                    parameters={parameters}
                                                                    devices={devices}
                                                                    credits={credits}
                                                                    deposits={deposits}
                                                                /> :
                                                                <div>cargando...</div>
                                                        }
                                                    </Route>
                                                    <Route exact path="/consult-certificates" >
                                                        {
                                                            (loading) ?
                                                                <ConsultCertificatesContainer
                                                                    getCertificatesCore={this.getCertificatesCore}
                                                                    certificates={certificates}
                                                                    parameters={parameters}
                                                                    user={user2}
                                                                    auth={user}
                                                                    classes={this.props}
                                                                    handleOpenSnack={this.handleOpenSnack}
                                                                    balances={filterArrayMoreEqual(balances, 'PRODUCTALIAS', ['AHORROS A LA VISTA',])}
                                                                /> :
                                                                <div>cargando...</div>
                                                        }
                                                    </Route>
                                                    <Route exact path="/suggestion" >
                                                        {
                                                            <SuggestionContainer
                                                                user={this.props.user}
                                                                handleOpenSnack={this.handleOpenSnack}
                                                                parameters={parameters}
                                                                usercore={this.props.user2}
                                                            />
                                                        }
                                                    </Route>
                                                    <Route exact path="/tranvia" >
                                                        {
                                                            (user && balances.length > 0) &&
                                                            <TranviaContainer
                                                                user={user2}
                                                                auth={this.props.user}
                                                                balances={filterArrayMoreEqual(balances, 'PRODUCTALIAS', ['AHORROS A LA VISTA',])}
                                                                handleOpenSnack={this.handleOpenSnack}
                                                                parameters={parameters}
                                                                devices={devices}
                                                                updateIpDevice={updateIpDevice}
                                                                getParametersTranviaServices={getParametersTranviaServices}
                                                                quotas={quotas}
                                                                getQuotas={this.props.getQuotas}
                                                            />
                                                        }
                                                    </Route>
                                                    <Route exact path="/vouchers-tranvia-pay" >
                                                        {
                                                            (loading) ?
                                                                <VoucherTranviaPayContainer
                                                                    user={user2}
                                                                    classes={this.props}
                                                                    handleOpenSnack={this.handleOpenSnack}
                                                                    balances={filterArrayMoreEqual(balances, 'PRODUCTALIAS', ['AHORROS A LA VISTA',])}
                                                                    parameters={parameters}
                                                                    devices={devices}
                                                                /> :
                                                                < div > cargando...</div>
                                                        }
                                                    </Route>
                                                    <Route exact path='/sendPayRole'>

                                                        <SendPayRoleContainer
                                                            getDeviceInfo={getDeviceData}
                                                            handleLogOut={this.setOnLogout}
                                                            handleOpenSnack={this.handleOpenSnack}
                                                            setLoading={() => console.log('cargando...')}
                                                        />
                                                    </Route>
                                                    <Route exact path='/validatePayRole'>

                                                        <ValidatePayRoleContainer
                                                            getDeviceInfo={getDeviceData}
                                                            handleLogOut={this.setOnLogout}
                                                            handleOpenSnack={this.handleOpenSnack}
                                                            setLoading={() => console.log('cargando...')}
                                                        />
                                                    </Route>
                                                    <Route exact path='/activityPayRole'>

                                                        <CheckPayrollContainer
                                                            getDeviceInfo={getDeviceData}
                                                            handleLogOut={this.setOnLogout}
                                                            handleOpenSnack={this.handleOpenSnack}
                                                            setLoading={() => console.log('cargando...')}
                                                        />
                                                    </Route>
                                                    <Route exact path='/transaction-activity/:type'
                                                      render={props => <TransactionsActivityContainer
                                                        getDeviceInfo={getDeviceData}
                                                        handleLogOut={this.setOnLogout}
                                                        handleOpenSnack={this.handleOpenSnack}
                                                        user={user}
                                                        devices={devices}
                                                        classes={this.props}
                                                        balances={filterArrayMoreEqual(balances, 'PRODUCTALIAS', ['AHORROS A LA VISTA',])}
                                                        typeTransaction={props.match.params.type}
                                                      />}
                                                    >
                                                    </Route>
                                                    {<Redirect from="*" to="/" />
                                                    }
                                                </Switch>
                                            </Router>

                                        } />
                                </ThemeProvider>
                        }
                        {
                            // window.postMessage('hola')
                            // ( localStorage.length === 0) ?


                        }
                        <ThemeProvider theme={themePrimary("", this.state.isDark)}>
                            <SnackBars
                                {...this.state}
                                oncloseSnack={this.handleOncloseSnack}
                            />
                        </ThemeProvider>
                    </div>
                </div>
            </div>
        );
    }
}


const mapDispatchToProps = state => {
    const { authentication, devices, userCodes, consolidates, checkbook,
        customers, codes, checkbookEmited, navigation, notifications, balances, beneficiary,
        credits, entitiesCore, institutionsCore, electricCompaniesCore, metersCore, periodsCore,
        levelsCore, agreements, loading, deposits, verificates, parameters, quotas, siim, agreementTypes, agreementsSwitchServices,
        foundations, otherServices, certificates, complements, precalificacion, documentos, menuItems, getCertificatesCore, getStates, states, company  } = state
    const user2 = state.user
    const { user } = authentication
    return {
        user, devices, userCodes, consolidates, checkbook,
        customers, authentication, user2, codes, checkbookEmited, navigation,
        notifications, balances, beneficiary, credits, entitiesCore, institutionsCore,
        electricCompaniesCore, metersCore, periodsCore, levelsCore, agreements, loading, deposits, verificates, parameters, quotas,
        siim, agreementTypes, agreementsSwitchServices, foundations, otherServices, certificates, complements, precalificacion, documentos, menuItems, getCertificatesCore, getStates, states, company
    };
}

export default connect(mapDispatchToProps, { ...allActions })(App)
